import { render, staticRenderFns } from "./skillsScores.vue?vue&type=template&id=4a487461&scoped=true&"
import script from "./skillsScores.vue?vue&type=script&lang=js&"
export * from "./skillsScores.vue?vue&type=script&lang=js&"
import style0 from "./skillsScores.vue?vue&type=style&index=0&id=4a487461&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a487461",
  null
  
)

export default component.exports